export default __webpack_public_path__ + "static/media/foot-logo.8f23b9ce.svg";